import { render, staticRenderFns } from "./AtomLabel.vue?vue&type=template&id=1553f605&scoped=true&functional=true&"
import script from "./AtomLabel.vue?vue&type=script&lang=ts&"
export * from "./AtomLabel.vue?vue&type=script&lang=ts&"
import style0 from "./AtomLabel.vue?vue&type=style&index=0&id=1553f605&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1553f605",
  null
  
)

export default component.exports